import TextList from "components/Admin/Questionnaire/List/TextList"
import React from "react"

const TextListPage = () => {
    return (
        <React.Fragment>
            <TextList />
        </React.Fragment>
    )
}
export default TextListPage
